import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PromotionsState } from './types';
import { ParsedPromo, PromoTypes } from '../../components/Layout/Promotions/types';
import { storageClaimedPromo } from '../../utils/storage';
import { ProductType, PromotionTabsType } from '../../components/Layout/Promotions/PromotionsBlock/types';

const initialState: PromotionsState = {
  productTabName: storageClaimedPromo.get() ? ProductType.REWARDS : ProductType.PROMOTIONS,
  promotionTab: PromotionTabsType.PROMOTIONS,
  loadPlatformPromotions:
    (JSON.parse(String(storageClaimedPromo.get())) as ParsedPromo)?.promoType === PromoTypes.WAGER_AND_GET
      ? false
      : true,
  activePromoType: null,
};

export const promotionsSlice = createSlice({
  name: 'promotions',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setProductTab: (state: PromotionsState, action: PayloadAction<ProductType>) => {
      return {
        ...state,
        productTabName: action.payload,
      };
    },
    setPromotionTabs: (state: PromotionsState, action: PayloadAction<PromotionTabsType>) => {
      return {
        ...state,
        promotionTab: action.payload,
      };
    },
    setLoadPlatformPromotions: (state: PromotionsState, action: PayloadAction<boolean>) => {
      return {
        ...state,
        loadPlatformPromotions: action.payload,
      };
    },
    setActivePromoType: (state: PromotionsState, action: PayloadAction<PromoTypes>) => {
      return {
        ...state,
        activePromoType: action.payload,
      };
    },
  },
});

export const { setProductTab, setPromotionTabs, setLoadPlatformPromotions, setActivePromoType } =
  promotionsSlice.actions;

export default promotionsSlice.reducer;
